import { motion } from "framer-motion";
import { Header } from "@/components/landing/Header";
import { Footer } from "@/components/landing/Footer";
import { useState } from "react";
import { SignupModal } from "@/components/landing/SignupModal";

const TerminosCondiciones = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Header onOpenModal={() => setIsModalOpen(true)} />
      
      <main className="pt-32 pb-24 px-6 md:px-12">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="inline-block text-[#E05D3A] text-sm font-semibold tracking-widest uppercase mb-4">
              Legal
            </span>
            <h1 className="font-outfit text-4xl sm:text-5xl font-light tracking-tight mb-4">
              Términos y Condiciones
            </h1>
            <p className="text-zinc-500 mb-12">Última actualización: Diciembre 2024</p>

            <div className="prose prose-invert prose-lg max-w-none space-y-8">
              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">1. Aceptación de los Términos</h2>
                <p className="text-zinc-400 leading-relaxed">
                  Al acceder y utilizar Antropia, aceptas quedar vinculado por estos Términos y Condiciones. 
                  Si no estás de acuerdo con alguna parte de estos términos, no debes utilizar nuestro servicio.
                </p>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">2. Descripción del Servicio</h2>
                <p className="text-zinc-400 leading-relaxed">
                  Antropia es una plataforma SaaS para gestión de consultas nutricionales potenciada por 
                  inteligencia artificial. El servicio incluye grabación de consultas, transcripción 
                  automática, generación de resúmenes, seguimiento de mediciones corporales y visualización 
                  de progreso para clientes.
                </p>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">3. Cuentas de Usuario</h2>
                <p className="text-zinc-400 leading-relaxed">
                  Para usar Antropia debes crear una cuenta proporcionando información precisa y completa. 
                  Eres responsable de mantener la confidencialidad de tu cuenta y contraseña, y de todas 
                  las actividades que ocurran bajo tu cuenta. Debes notificarnos inmediatamente cualquier 
                  uso no autorizado.
                </p>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">4. Planes y Facturación</h2>
                <div className="text-zinc-400 leading-relaxed space-y-4">
                  <p><strong className="text-white">Plan Gratuito:</strong> Limitado a 3 clientes, sin acceso a funciones de IA.</p>
                  <p><strong className="text-white">Plan Pro:</strong> Suscripción mensual con precio por cliente basado en volumen. Incluye tokens de IA.</p>
                  <p><strong className="text-white">Trial:</strong> 14 días de acceso completo sin necesidad de tarjeta de crédito.</p>
                  <p><strong className="text-white">Tokens de IA:</strong> Aproximadamente 15-20 minutos de procesamiento de consulta. Los tokens no utilizados no se acumulan. Tokens adicionales disponibles para compra.</p>
                  <p><strong className="text-white">Facturación:</strong> Mensual, al inicio de cada período de facturación. No reembolsable excepto por cancelación.</p>
                </div>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">5. Uso Aceptable</h2>
                <p className="text-zinc-400 leading-relaxed mb-4">
                  El servicio debe usarse para consultoría nutricional legítima. Actividades prohibidas incluyen:
                </p>
                <ul className="text-zinc-400 list-disc pl-6 space-y-2">
                  <li>Grabar sin consentimiento informado</li>
                  <li>Emitir diagnósticos médicos</li>
                  <li>Compartir credenciales de acceso</li>
                  <li>Ingeniería inversa de algoritmos de IA</li>
                  <li>Actividades ilegales o suplantación de identidad</li>
                  <li>Almacenar datos de menores sin consentimiento</li>
                </ul>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">6. Propiedad Intelectual</h2>
                <p className="text-zinc-400 leading-relaxed">
                  El diseño del servicio, código, algoritmos de IA, marca y logos son propiedad de Antropia. 
                  Los datos generados por el usuario pertenecen al usuario. Antropia puede usar datos 
                  anonimizados y agregados para mejoras del servicio.
                </p>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">7. Privacidad y Datos</h2>
                <p className="text-zinc-400 leading-relaxed">
                  El tratamiento de datos está regido por nuestra Política de Privacidad y el Acuerdo de 
                  Procesamiento de Datos (DPA).
                </p>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">8. Limitación de Responsabilidad</h2>
                <p className="text-zinc-400 leading-relaxed">
                  Antropia es una herramienta de apoyo. Los resúmenes de IA son orientativos, no constituyen 
                  consejo médico. El profesional es responsable de validar toda la información. La 
                  responsabilidad de Antropia está limitada a los montos pagados en los últimos 12 meses.
                </p>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">9. Disponibilidad del Servicio</h2>
                <p className="text-zinc-400 leading-relaxed">
                  Nos esforzamos por mantener una disponibilidad del 99.5%. El mantenimiento programado 
                  se notificará con anticipación. No somos responsables por factores externos.
                </p>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">10. Cancelación y Terminación</h2>
                <div className="text-zinc-400 leading-relaxed space-y-4">
                  <p><strong className="text-white">Cancelación por usuario:</strong> Posible en cualquier momento, acceso continúa hasta el final del período de facturación.</p>
                  <p><strong className="text-white">Retención post-cancelación:</strong> Datos accesibles por 90 días.</p>
                  <p><strong className="text-white">Exportación de datos:</strong> El usuario puede exportar datos antes de la eliminación permanente.</p>
                  <p><strong className="text-white">Terminación por Antropia:</strong> Por violaciones o actividad fraudulenta.</p>
                </div>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">11. Modificaciones a los Términos</h2>
                <p className="text-zinc-400 leading-relaxed">
                  Antropia puede modificar estos términos con 30 días de aviso para cambios materiales. 
                  El uso continuado implica aceptación.
                </p>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">12. Contacto</h2>
                <p className="text-zinc-400 leading-relaxed">
                  Para consultas legales: <a href="mailto:legal@antropia.app" className="text-[#E05D3A] hover:underline">legal@antropia.app</a>
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </main>

      <Footer />
      <SignupModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};

export default TerminosCondiciones;
